import { Button } from "reactstrap";
import useLazyFetch from "src/hooks/useLazyFetch";

interface IProps {
  initialValues: {
    id: string | number;
    name: string;
    device_id: string;
  };
  onClose: () => void;
  onReload: () => void;
}

const DeleteDevice = ({ initialValues, onClose, onReload }: IProps) => {
    const [onDelete, {loading}] = useLazyFetch({
        url: "https://api.automa.id/api/iot/lock/bridges/delete",
        method: "POST"
    })
  return (
    <>
      <p>Are you sure you want delete this device?</p>
      <div className="d-flex justify-content-end w-100">
        <Button
          className="w-25 me-2"
          color="secondary ms-2"
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          className="w-50"
          color="danger"
          disabled={loading}
          onClick={() => {
            onDelete({
                path: "/"+initialValues.id
            }, ()=>{
                onReload();
                onClose();
            })
          }}
        >
          Delete
        </Button>
      </div>
    </>
  );
};

export default DeleteDevice;
